import axios from 'axios';
import {API} from './api';
// Isolated client for explicit owner recovery. It sends the staff cookie,
// never a customer preview credential or an inferred workspace header.
const ownerClient=axios.create({baseURL:API,withCredentials:true,timeout:10000});
export async function selectedPreviewWorkspace(){
 const [env,outlet]=await Promise.all([ownerClient.get('/env/status'),ownerClient.get('/outlets/current')]);
 if(!['owner','admin','user'].includes(env.data.role))throw Error('Sign in to the staff app as the owner to reconnect this Test page.');
 if(!['test','demo'].includes(env.data.env))throw Error('Select Test or Demo in the staff app before reconnecting.');
 if(!env.data.initialized||!outlet.data.id)throw Error('Select a ready outlet workspace in the staff app first.');
 return {env:env.data.env,outlet_id:outlet.data.id,outlet_name:outlet.data.name||'selected outlet'};
}
export async function reconnectOrderPreview(selected){
 const {data}=await ownerClient.post('/env/customer-preview',{expected_env:selected.env,expected_outlet_id:selected.outlet_id});
 if(data.env!==selected.env||data.outlet_id!==selected.outlet_id||!data.preview_token)throw Error('The selected workspace changed. Refresh the connection options and try again.');
 return data.preview_token;
}
export function reconnectedOrderPath(token,href=window.location.href){
 const next=new URL(href);next.searchParams.set('preview',token);return next.pathname+next.search+next.hash;
}
export function openReconnectedOrder(token){
 // Full reload resets request epochs. The URL supplies the new credential
 // even if storage is unavailable; the next request replaces saved context.
 window.location.replace(reconnectedOrderPath(token));
}
